import React, { useContext, useMemo } from 'react';
import { FeatureFlagContext } from './FeatureFlagContext.js';
import { FeatureFlagScope } from './FeatureFlagScope.js';

function FeatureFlags({
  children,
  flags
}) {
  const parentFeatureFlags = useContext(FeatureFlagContext);
  const value = useMemo(() => {
    const scope = FeatureFlagScope.merge(parentFeatureFlags, FeatureFlagScope.create(flags));
    return scope;
  }, [parentFeatureFlags, flags]);
  return /*#__PURE__*/React.createElement(FeatureFlagContext.Provider, {
    value: value
  }, children);
}
FeatureFlags.displayName = "FeatureFlags";

export { FeatureFlags };
